// ** Initial State
const initialState = {
  newFacility: null,
  notifySuccessNewFacility: null,
  notifyFailedNewFacility: null,

  detailFacility: null,
  notifySuccessGetDetailFacility: null,
  notifyFailedGetDetailFacility: null,

  notifySuccessUpdateFacility: null,
  notifyFailedUpdateFacility: null
}

const FacilitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SUCCESS_NEW_FACILITY':
      return {
        ...state, 
        newFacility: {
         ...action.data,
         accessToken: null,
         refreshToken: null
        },
        notifySuccessNewFacility: true
      }
    case 'FAILED_NEW_FACILITY':
      return {
        ...state,         
        notifyFailedNewFacility: true
      }
    case 'CLEAR_NEW_FACILITY':
      return {
        ...state,     
        notifySuccessNewFacility: null,    
        notifyFailedNewFacility: null
      }  
    case 'GET_DETAIL_FACILITY':
      return {
        ...state, 
        notifySuccessGetDetailFacility: true, 
        detailFacility: action.facilityData
      }
    case 'FAILED_DETAIL_FACILITY':
      return {
        ...state, 
        notifyFailedGetDetailFacility: true        
      }
    case 'RESET_DETAIL_FACILITY':
      return {
        ...state, 
        notifySuccessGetDetailFacility: null,
        notifyFailedGetDetailFacility: null        
      }
    case 'SUCCESS_UPDATE_FACILITY':
      return {
        ...state,
        notifySuccessUpdateFacility: true
      }
    case 'FAILED_UPDATE_FACILITY':
      return {
        ...state,
        notifyFailedUpdateFacility: true
      }
    case 'RESET_UPDATE_FACILITY':
      return {
        ...state,
        notifySuccessUpdateFacility: null,
        notifyFailedUpdateFacility: null
      }
    default:
      return state
  }
}

export default FacilitiesReducer
